import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadMixpanelScript } from '../redux/mixpanel/mixpanelThunk';
import { Step } from './Step';
import { WizardProgress } from './WizardSteps';
import { NotificationsArea } from './NotificationsArea';
import {
  isDocumentResubmission,
  getIsFormLoading,
  getHash,
} from '../redux/form/formSelectors';
import { DocumentsResubmit } from './DocumentsResubmit';
import { ContinueInAppBanner } from './ContinueInAppBanner';
import { UpdateAppBanner } from './UpdateAppBanner';
import { getScriptDirection } from '../redux/localization/localizationSelectors';
import { getIsLoadingLibrariesEnabled } from '../redux/settings/settingsSelector';

export const Signup: React.FC = () => {
  const hash = useSelector(getHash);
  const isLoading = useSelector(getIsFormLoading);
  const scriptDirection = useSelector(getScriptDirection);
  const isLoadingLibrariesEnabled = useSelector(getIsLoadingLibrariesEnabled);

  const dispatch = useDispatch();
  const isResubmission = useSelector(isDocumentResubmission);

  React.useEffect(() => {
    document.documentElement.dir = scriptDirection;
  }, [scriptDirection]);

  React.useEffect(() => {
    if (hash && !isLoading && isLoadingLibrariesEnabled) {
      dispatch(loadMixpanelScript());
    }
  }, [dispatch, isLoading, hash, isLoadingLibrariesEnabled]);

  if (isResubmission) {
    return (
      <div>
        <DocumentsResubmit hash={hash} />
      </div>
    );
  }

  return (
    <div>
      <WizardProgress />
      <NotificationsArea />
      <ContinueInAppBanner />
      <UpdateAppBanner />
      <Step hash={hash} />
    </div>
  );
};
